<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <header-add
            :typeEvent="1"
            route="/works/activityvalues/create"
            v-if="isCreate()"
          />
        </div>
        <div v-if="isIndex()">
          <card-header
            @searchedQuery="searchedQuery"
            class="mr-3 mt-4"
          ></card-header>
          <master-table
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="true"
            :widthColumnStatus="180"
          >
            <template slot="addColumns">
              <table-column-badges
                prop="businesses[0].name"
                :label="$t('common_words.associated_companies2')"
                fromData="businesses"
                textBadge="name"
                :minWidth="200"
              />
              <table-column-badges
                prop="farms[0].name"
                :label="$t('common_words.farm')"
                fromData="farms"
                textBadge="name"
                :minWidth="150"
              />
              <table-column-badges
                prop="lots[0].name"
                :label="$t('common_words.allotments')"
                fromData="lots"
                textBadge="name"
                :minWidth="150"
              />
            </template>
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                @handleView="handleView"
                @handleEdit="handleEdit"
                @handleDelete="handleDelete"
                @handleActivate="handleActivate"
                :canDisable="true"
                :minWidth="120"
                :howMuchTimePassed="['start_date', 1, 'months']"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" />
        <export-tables
          :pdf="{
            filename: `${$t('labor.activities_value')}.pdf`,
            route: 'works/activityvalues/pdf',
          }"
          :xls="{
            filename: `${$t('labor.activities_value')}.xslx`,
            route: 'works/activityvalues/excel',
          }"
        />
        <br />
      </card>
      <el-dialog
        v-if="isShow()"
        :title="$t('common_words.activities_value')"
        :visible.sync="modals.read"
        width="64%"
        top="2%"
      >
        <div class="card" v-if="rowData">
          <div class="card-body" v-if="rowData">
            <table class="table">
              <tbody>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.activity') }}:</strong>
                    </h6>
                    <el-tag style="height: auto" type="info">
                      {{ rowData.activity.name }} <br />
                      {{ $t('common_words.value') }}: ${{
                        formatNumber(rowData.price)
                      }}
                      <br />
                      {{ $t('labor.unit') }}:
                      {{ rowData.activity.unit_production_name }} <br />
                      {{ $t('common_words.category') }}:
                      {{ rowData.activity.group_name }}
                    </el-tag>
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('labor.hour_extra') }}:</strong>
                    </h6>
                    {{ rowData.extra_hours === 0 ? 'No' : 'Si' }}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6>
                      <strong>{{ $t('common_words.date') }}:</strong>
                    </h6>
                    {{ rowData.start_date }}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.companies2') }}:</strong>
                    </h6>
                    <span
                      v-for="(value, index) in rowData.businesses_names"
                      :key="index"
                    >
                      <el-tag type="info">
                        {{ value }}
                      </el-tag>
                    </span>
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.farms2') }}:</strong>
                    </h6>
                    <template v-if="rowData.farms.length > 0">
                      <span
                        v-for="(value, index) in rowData.farms"
                        :key="index"
                      >
                        <el-tag type="info">
                          {{ value.name }}
                        </el-tag>
                      </span>
                    </template>
                    <el-tag v-else type="warning">
                      {{ $t('common_words.no_assigned') }}
                    </el-tag>
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.allotment(s)') }}:</strong>
                    </h6>
                    <template v-if="rowData.lots.length > 0">
                      <span v-for="(value, index) in rowData.lots" :key="index">
                        <el-tag type="info">
                          {{ value.name }}
                        </el-tag>
                      </span>
                    </template>
                    <el-tag v-else type="warning">{{
                      $t('common_words.no_assigned')
                    }}</el-tag>
                  </td>
                </tr>
                <td>
                  <h6 class="mb-2">
                    <strong>{{ $t('labor.rate_additional') }}:</strong>
                  </h6>
                  <template v-if="rowData.rate_types.length > 0">
                    <span
                      v-for="(value, index) in rowData.rate_types"
                      :key="index"
                    >
                      <el-tag style="height: auto" type="info">
                        {{ $t('common_words.name') }}:
                        {{
                          value.activity_rate
                            ? value.activity_rate.name
                            : $t('common_words.no_assigned')
                        }}
                        <br />
                        {{ $t('common_words.value') }}:
                        {{
                          value.rate_value
                            ? `$${formatNumber(value.rate_value)}`
                            : 'N/A'
                        }}
                        <br />
                        {{ $t('common_words.company') }}:
                        {{ value.business ? value.business.name : 'N/A' }}
                        <br />
                        {{ $t('common_words.farm') }}:
                        {{ value.farm ? value.farm.name : 'N/A' }}
                        <br />
                        {{ $t('common_words.allotment') }}:
                        {{ value.lot ? value.lot.name : 'N/A' }}
                      </el-tag>
                    </span>
                  </template>
                  <el-tag v-else type="warning">{{
                    $t('common_words.no_assigned')
                  }}</el-tag>
                </td>
              </tbody>
            </table>
          </div>
          <div class="card-footer footer-date-at" v-if="rowData">
            <p class="text-muted">
              <small
                >{{ $t('common_words.created_on') }}:
                {{ rowData.created_at }}</small
              >
            </p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './activity-values-table';
import Fuse from 'fuse.js';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },
  computed: configTable().Search,
  data() {
    return {
      Table: {},
      Search: {},
      pagination: {},
      tableColumns: [],
      businesses: [],
    };
  },
  mixins: [MixinMasters, MixinPermissions, MixinMenu, MixinExport],
  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    formatNumber(value) {
      return Formatter.formatMoney(Number(value));
    },

    handleView(_, row) {
      this.rowData = { ...row };
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(_, row) {
      this.editForm = { ...row };
      this.editForm.rateNumber = row.rate_types.length;
      sessionStorage.setItem('editForm', JSON.stringify(this.editForm));
      this.$router.push({
        path: '/works/activityvalues/edit',
      });
    },

    handleDelete(index, row) {
      this.activityValueForm = row;
      SweetAlert.disable(`${i18n.t('common_words.activity_report_edit')}`).then(
        (result) => {
          if (result.value) this.deleteActivityValue();
        }
      );
    },

    handleActivate(index, row) {
      this.model = row;
      SweetAlert.default(
        `${i18n.t('common_words.activity_report_edit')}`,
        null,
        i18n.t('common_words.accept'),
        1
      ).then((result) => {
        if (result.value) this.activateActivityValue();
      });
    },

    activateActivityValue() {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        this.model.route = 'works/activityvalues/activate';
        Axios.updateMaster(this.model)
          .then((response) => this.modifyTable(1, this.model.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    deleteActivityValue() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.activityValueForm.route = 'works/activityvalues';
        Axios.destroyMaster(this.activityValueForm)
          .then((response) => {
            this.modifyTable(1, this.activityValueForm.id, response);
          })
          .catch((error) => this.showMessageErrors(error));
      }
    },
    setupTable() {
      const { Table, Search } = configTable();
      // Assign the Table and Search objects to your data properties
      this.Table = Table;
      this.Search = Search;
      this.tableColumns = Table.tableColumns;
      this.pagination = Table.pagination;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Promise.all([Axios.getMasters('works/activityvalues')])
        .then((response) => {
          const [responseActivityValues] = response;
          this.tableData = responseActivityValues.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('works');
  },

  destroyed() {
    this.deselectedItemOnMenu('works');
  },
};
</script>
